import { IRootState } from '../../../store'
import { INemsisCustomDataOptions } from '../store/options.types'

export const getNemsisCustomDataOptionsSelector = (state: IRootState): INemsisCustomDataOptions =>
  state.options.nemsisCustomDataOptions
